import React, { Component } from "react";

class Intro extends Component {
  render() {
    return (
      <div>
        <div
          id="intro"
          style={{
            zIndex: "10",
            position: "fixed",
            width: "100%",
            height: "100%",
            display: "none",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={function (e) {
            if (e.target !== e.currentTarget) return;
            e.currentTarget.style.display = "none";
          }}
        >
          <div
            id="container"
            style={{
              display: "flex",
              flexDirection: "column",
              position: "fixed",
              width: "auto",
              height: "auto",
              maxWidth: "80%",
              maxHeight: "80%",
              backgroundColor: "#FFF",
              padding: "0px 30px",
              borderRadius: "5px",
              border: "2px solid #555",
              boxShadow:
                "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
              overflowY: "scroll",
            }}
            onClick={function (e) {
              console.log("container clicked");
            }}
          >
            <h2 style={{}}>StateFarm<i>inda</i>House!</h2>
            <span style={{ wordWrap: "break-word", marginBottom: "8px" }}>
              Feel free to tap, drag, zoom and explore the Insurance world!
            </span>
            <p>- Jake from StateFarm</p>
            <div style={{ wordWrap: "break-word", marginBottom: "16px" }}>
              <i></i>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src='/Images/jake_hat.PNG'
                alt="instruction gif"
                style={{
                  position:'fixed',
                  height: "45%",
                  marginBottom: "6px",
                  borderRadius: "5px",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Intro;
